export const saveToLocal = (key: string, data: any) => {
  localStorage.setItem(key, JSON.stringify(data));
};

export const getFromLocal = (key: string) => {
  const data = localStorage.getItem(key);
  return data ? JSON.parse(data) : null;
};

export const removeFromLocal = (key: string) => {
  localStorage.removeItem(key);
};

export const OFFLINE_KEYS = {
  TAREAS: 'offline_tareas',
  ENCUESTAS: 'offline_encuestas',
  PENDING_RESPONSES: 'pending_responses',
  PENDING_COORDINATES: 'pending_coordinates',
  PENDING_TASKS: 'pending_tasks',
};
